import styled from 'styled-components'
import { facebookButton } from 'app/sofia/resources/theme/css'

export const Container = styled.div`
  address {
    font-size: 14px;
    font-style: normal;

    > a {
      display: block;
    }
  }

  .footer {
    &__contact-info {
      line-height: 1.4;

      > a {
        font-size: 18px;
      }
    }

    &__button {
      ${facebookButton}
      margin: 10px 0 15px;
    }
  }
`
